/**
 * Plume — Free Gift handler (minimal, no auto-reload)
 *
 * Click handlers only. No fetch hooks, no XHR hooks, no auto-enforcement.
 * The "max 1 per cart" rule is enforced ARCHITECTURALLY by:
 *   1. The custom product template (templates/product.complimentary-gift.json)
 *      which strips the Add-to-Cart form from the free pencil's PDP entirely.
 *   2. The cart drawer snippet showing the "added" state when gift is in cart,
 *      hiding the Add button.
 *
 * Previous auto-reload enforcement caused infinite reload loops + Cloudflare
 * rate-limit triggers. Removed entirely.
 */
(function () {
  'use strict';

  var FREE_GIFT_PROPERTY = '_free_gift';
  var DISMISS_KEY = 'plumeFreeGiftBarDismissed';

  function addLine(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { _free_gift: 'true' }
        }]
      })
    }).then(function (r) { return r.json(); });
  }

  function removeLineByKey(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  function getSelectedVariantId(blockEl) {
    var checked = blockEl.querySelector('[data-free-gift-variant]:checked:not(:disabled)');
    if (checked) return checked.value;
    var firstAvailable = blockEl.querySelector('[data-free-gift-variant]:not(:disabled)');
    return firstAvailable ? firstAvailable.value : null;
  }

  function openCartDrawer() {
    var existingTrigger = document.querySelector(
      '[data-drawer-id="sidebar-cart"][data-action="open-drawer"]'
    );
    if (existingTrigger) {
      existingTrigger.click();
      return true;
    }
    if (window.theme && typeof window.theme.openDrawer === 'function') {
      window.theme.openDrawer('sidebar-cart');
      return true;
    }
    return false;
  }

  function safeGetDismissed() {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; }
    catch (e) { return false; }
  }
  function safeSetDismissed() {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); }
    catch (e) { /* noop */ }
  }
  function applyDismissedStateToBars() {
    if (!safeGetDismissed()) return;
    var bars = document.querySelectorAll('.FreeGiftPromoBar[data-dismissible="1"]');
    for (var i = 0; i < bars.length; i++) {
      bars[i].style.display = 'none';
    }
  }

  // ──────────────────────────────────────────────────────────────────
  // Goto navigation (GET, no POST resubmit prompt)
  // ──────────────────────────────────────────────────────────────────
  function softNavigate() {
    window.location.assign(window.location.pathname + window.location.search + window.location.hash);
  }

  // ──────────────────────────────────────────────────────────────────
  // Single delegated click handler
  // ──────────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    // Promo bar dismiss
    var dismissBtn = e.target.closest('[data-action="dismiss-free-gift-bar"]');
    if (dismissBtn) {
      e.preventDefault();
      e.stopPropagation();
      var bar = dismissBtn.closest('.FreeGiftPromoBar');
      if (bar) bar.style.display = 'none';
      safeSetDismissed();
      return;
    }

    // Promo bar / banner "open cart drawer" links
    var drawerOpenLink = e.target.closest('[data-free-gift-open-cart]');
    if (drawerOpenLink) {
      // Only consume the click if we can actually open the drawer.
      // If not (cart_type set to "Page", drawer selectors differ, JS error),
      // let the link's href="/cart" do its natural thing.
      if (openCartDrawer()) {
        e.preventDefault();
      }
      return;
    }

    // Cart drawer Add / Remove buttons
    var blockEl = e.target.closest('[data-free-gift-block]');
    if (!blockEl) return;

    var addBtn = e.target.closest('[data-free-gift-add]');
    var removeBtn = e.target.closest('[data-free-gift-remove]');

    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = getSelectedVariantId(blockEl);
      if (!variantId) return;
      addBtn.setAttribute('disabled', 'disabled');
      var originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      addLine(variantId)
        .then(function () { softNavigate(); })
        .catch(function () {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = originalLabel;
        });
      return;
    }

    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var key = blockEl.getAttribute('data-gift-line-key');
      if (!key) return;
      removeBtn.setAttribute('disabled', 'disabled');
      removeLineByKey(key)
        .then(function () { softNavigate(); })
        .catch(function () { removeBtn.removeAttribute('disabled'); });
      return;
    }
  });

  // Init: only apply dismissed state. No enforcement.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDismissedStateToBars);
  } else {
    applyDismissedStateToBars();
  }
})();
